angular.module('flowingly.runner.print').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider) {
  $stateProvider.state('app.print', {
    abstract: true,
    url: '/print',
    template: '<ui-view></ui-view>'
  });
}
